<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <circle 
                class="a" cx="17" cy="17" r="17" 
                :fill="color"/>
                <line fill="none" stroke="#2f3435" stroke-linecap="square" stroke-miterlimit="10" x1="12.36" y1="20.94" x2="8.42" y2="17"/>
                <line fill="none" stroke="#2f3435" stroke-linecap="square" stroke-miterlimit="10" x1="8.42" y1="17" x2="12.36" y2="13.06"/>
                <line fill="none" stroke="#2f3435" stroke-linecap="square" stroke-miterlimit="10" x1="21.64" y1="13.06" x2="25.58" y2="17"/>
                <line fill="none" stroke="#2f3435" stroke-linecap="square" stroke-miterlimit="10" x1="25.58" y1="17" x2="21.64" y2="20.94"/>
                <line fill="none" stroke="#2f3435" stroke-linecap="square" stroke-miterlimit="10" x1="13.59" y1="23.44" x2="20.65" y2="10.56"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'ApiIcon',
  props: {
    color: {
      type: String,
      default: 'rgb(165, 216, 103)', // fallback color
    },
  },
}
</script>

<style scoped>
    svg {
        width:34px;
        height: 34px;
    }
</style>